import script from "./Ejemplos.vue?vue&type=script&setup=true&lang=js"
export * from "./Ejemplos.vue?vue&type=script&setup=true&lang=js"

import "./Ejemplos.vue?vue&type=style&index=0&id=141ff83e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-141ff83e"]])

export default __exports__